/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order type:   * `DROP` - cargo delivery from the warehouse to the location   * `PICKUP` - cargo pickup at the location and delivery to the warehouse 
 */
export enum OrderTypeDelivery {
    DROP = 'DROP',
    PICKUP = 'PICKUP'
};

